import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { verifyStripeSessionThunk } from '../Payment/paymentState/paymentThunk';
import styles from './PaymentSuccess.module.css';

const PaymentSuccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { verifyLoading, verifySuccess, verifyError } = useSelector(
    (state) => state.payment
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    dispatch(verifyStripeSessionThunk(sessionId || ''));
  }, [dispatch]);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.card}>

        {verifyLoading && (
          <>
            <div className={styles.spinner} />
            <h2 className={styles.title}>{t('Verifying your payment...')}</h2>
            <p className={styles.subtitle}>
              {t('Please wait while we confirm your subscription.')}
            </p>
          </>
        )}

        {!verifyLoading && verifySuccess && (
          <>
            <div className={`${styles.icon} ${styles.iconSuccess}`}>&#10003;</div>
            <h2 className={styles.title}>{t('Payment Successful!')}</h2>
            <p className={styles.subtitle}>
              {t('Your AdminCat subscription is now active. Thank you!')}
            </p>
            <button className={styles.button} onClick={() => navigate('/dashboard')}>
              {t('Go to Dashboard')}
            </button>
          </>
        )}

        {!verifyLoading && verifyError && (
          <>
            <div className={`${styles.icon} ${styles.iconError}`}>&#x2715;</div>
            <h2 className={styles.title}>{t('Payment Verification Failed')}</h2>
            <p className={styles.subtitle}>
              {t('We could not verify your payment. If you were charged, please contact support.')}
            </p>
            <p className={styles.errorMessage}>{verifyError}</p>
            <button className={styles.button} onClick={() => navigate('/payment')}>
              {t('Try Again')}
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default PaymentSuccess;
